<template>
  <div class="uid-token">
    <p class="uid-token-title">
      {{ uidTokenTitle }}<span class="ask" @click="showGuidePopup"></span>
    </p>
    <div class="uid-token-content">
      <p
        class="uid-token-back"
        v-if="!isPopupMode"
        @click="backToSelectLoginWay"
      >
        <span class="uid-token-back-ico"></span>{{ letter.couponReturn }}
      </p>
      <p class="uid-token-input-label" v-if="needInputUid">
        {{ letter.uidInputUid }}
      </p>
      <input
        v-if="needInputUid"
        v-model="uid"
        class="uid-token-input-box"
        placeholder=""
        @focus="initViewport"
        :disabled="isPopupMode"
      />
      <p class="uid-token-input-label">
        {{ isJpPlatform ? letter.jpUidInputToken : letter.uidInputToken }}
      </p>
      <div class="uid-token-dynamic-code">
        <input
          v-for="(item, index) in dynamicCodeInput"
          v-model="item.num"
          :id="'dynamicCodeInput' + index"
          :key="index"
          @input="inputFinish(index)"
          @focus="adjust(index)"
          @keydown="inputDirection($event, index)"
          maxlength="1"
          class="uid-token-input-box"
          type="number"
        />
      </div>
      <p class="uid-token-input-label" v-if="needVerticationCode">
        {{ letter.uidInputCode }}
      </p>
      <div class="uid-token-verification-code" v-if="needVerticationCode">
        <input
          v-model="verificationCode"
          class="uid-token-input-box verification"
          placeholder=""
          @focus="initViewport"
        />
        <img
          class="verification-img"
          :src="verificationImgSrc"
          alt="verificationImg"
        />
        <span class="refresh-ico" @click="refreshVerificationImg"></span>
      </div>
      <Button
        type="fillLightVh"
        class="uid-token-login-btn"
        pointClass="j-uid-token-login-btn"
        href="javascript:void(0);"
        @click="uidTokenLogin"
        :loading="loading"
      >
        {{ letter.login }}
      </Button>
    </div>
    <uid-token-guide-popup
      v-show="showGuide"
      @hidePopup="showGuide = false"
    ></uid-token-guide-popup>
    <!-- 江美专属uid弹窗 -->
    <beauty-token-guide-popup
      v-if="gameId == 2"
      v-bind:visible.sync="visibleBeautyGuide"
    ></beauty-token-guide-popup>
  </div>
</template>

<script type="text/javascript">
import globalConfig from '@utiles/officialStore/globalConfig';
import UidTokenGuidePopup from './UidTokenGuidePopup.vue';
import BeautyTokenGuidePopup from '@components/officialStore/login/BeautyTokenGuidePopup.vue';
import {
  SWITCH_SERVER,
  UPDATE_PC_SERVER_ID,
  UPDATE_ROLE_LIST,
  GET_SERVER_LIST,
  UPDATE_LOADING
} from '@store/officialStore';
import {
  GO_UID_TOKEN_LOGIN,
  UPDATE_UID_TOKEN_LOGIN_STATUS,
  CHECK_NEED_VERIFICATION_CODE
} from '@store/officialStore/login';
import { GET_JPSTORE_TOKEN_LOGIN_BY_UID } from '@store/officialStore/jp';
import { initViewport } from '@utiles/officialStore/index';
import { mapGetters } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'uidTokenLogin',
  props: {
    // 是否是弹窗模式 {
    isPopupMode: {
      type: Boolean,
      default: false
    },
    // 弹窗模式自定义标题
    popupModeTitle: {
      type: String,
      default: ''
    },
    defaultUid: {
      type: String,
      default: ''
    },
    // 是否需要UID输入
    needInputUid: {
      type: Boolean,
      default: true
    },
    // 需要的动态令牌数字数量
    uidNum: {
      type: Number,
      default: 4,
      validator: value => {
        return typeof value === 'number' && value >= 4;
      }
    }
  },
  data() {
    // 初始化dynamicCodeInput
    const initDynamicCodeInput = () => {
      const dynamicCodeInput = [];
      for (let i = 0, len = this.uidNum; i < len; i++) {
        dynamicCodeInput.push({ num: '' });
      }
      return dynamicCodeInput;
    };

    return {
      uid: '',
      dynamicCode: '',
      dynamicCodeInput: initDynamicCodeInput(),
      activeInput: 0,
      verificationCode: '',
      verificationImgSrc: `//gpassport.${mainHost}/center/ajax/get_code`,
      canUidTokenLogin: true,
      showGuide: false,
      loading: false,
      needVerticationCode: false,
      visibleBeautyGuide: false
    };
  },
  computed: {
    ...mapGetters(['isJpPlatform']),
    gameId() {
      return this.$store.state.gameId;
    },
    letter() {
      return this.$store.state.letter;
    },
    uidTokenTitle() {
      if (this.isPopupMode) {
        return this.popupModeTitle;
      }
      return this.isJpPlatform ? this.letter.jpUidToken : this.letter.uidToken;
    }
  },
  created() {
    if (this.isPopupMode) {
      this.uid = this.defaultUid;
    }
    if (this.isJpPlatform) {
      return;
    }
    this.checkNeedVerificationCode();
  },
  methods: {
    showGuidePopup() {
      if (this.isJpPlatform) {
        this.visibleBeautyGuide = true;
      } else {
        this.showGuide = true;
      }
    },
    adjust(index) {
      this.initViewport();
      let dom = document.getElementById('dynamicCodeInput' + this.activeInput);
      if (this.activeInput == this.uidNum) {
        document.getElementById('dynamicCodeInput3').focus();
        return;
      }
      if (index != this.activeInput && dom) {
        dom.focus();
      }
    },
    inputDirection(event, index) {
      this.initViewport();
      let val = this.dynamicCodeInput[index].num;
      if (event.keyCode == 8 && val == '') {
        let dom = document.getElementById('dynamicCodeInput' + (index - 1));
        this.activeInput = index - 1;
        dom && dom.focus();
      }

      if (event.keyCode != 8 && val != '') {
        let dom = document.getElementById('dynamicCodeInput' + (index + 1));
        this.activeInput = index + 1;
        dom && dom.focus();
      }
    },
    inputFinish(index) {
      this.initViewport();
      // input使用type=number时候ios中每次点完数字，键盘都自动换回英文等其他键盘，使用type=number会使maxlength失效，需要js控制一下
      if (this.dynamicCodeInput[index].num.length > 1) {
        this.dynamicCodeInput[index].num = this.dynamicCodeInput[
          index
        ].num.slice(0, 1);
      }
      let val = String(this.dynamicCodeInput[index].num).replace(/\D/g, '');
      if (!val) {
        this.dynamicCodeInput[index].num = '';
        this.dynamicCode = '';
        return;
      }
      this.activeInput = val ? index + 1 : index;
      let dom = document.getElementById('dynamicCodeInput' + this.activeInput);
      dom && dom.focus();
      if (index == this.dynamicCodeInput.length - 1) {
        let code = this.dynamicCodeInput.map(item => item.num).join('');
        if (code.length == this.uidNum) {
          this.dynamicCode = code;
        }
      }
    },
    refreshVerificationImg() {
      this.verificationImgSrc = `//gpassport.${mainHost}/center/ajax/get_code?${this.randomNumber(
        1,
        100000
      )}`;
      this.verificationCode = '';
    },
    checkInputValid() {
      if (this.needInputUid && !this.uid) {
        alert(this.letter.uidInputUid);
        return false;
      }

      if (!this.dynamicCode) {
        alert(this.letter.uidInputToken);
        return false;
      }

      if (!this.verificationCode && this.needVerticationCode) {
        alert(this.letter.uidInputCode);
        return false;
      }

      return true;
    },
    resetDynamicCodeInput() {
      this.dynamicCodeInput.forEach(item => {
        item.num = '';
      });
      this.dynamicCode = '';
      this.activeInput = 0;
    },
    // 全球和日本令牌登录总入口
    uidTokenLogin() {
      clickButton({
        btnName: 'login-way-token-confirm'
      });
      if (!this.checkInputValid()) {
        return;
      }
      if (!this.canUidTokenLogin) {
        return;
      }
      this.canUidTokenLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.isJpPlatform ? this.jpUidTokenLogin() : this.globalUidTokenLogin();
    },
    // 全球和日本令牌登录成功公共逻辑
    tokenLoginSuccessHandle() {
      if (this.isPopupMode) {
        this.$store.commit(UPDATE_LOADING, false);
        this.$emit('loginSuccess');
      } else {
        this.$store.commit(SWITCH_SERVER, 0);
        this.$store.commit(UPDATE_PC_SERVER_ID, 0);
        this.$store.commit(UPDATE_ROLE_LIST, []);
        this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
          this.$store.commit(UPDATE_LOADING, false);
        });
      }
      this.loading = false;
    },
    // 全球和日本令牌登录失败公共逻辑
    tokenLoginFailHandle(res) {
      this.loading = false;
      this.$store.commit(UPDATE_LOADING, false);
      this.canUidTokenLogin = true;
      this.resetDynamicCodeInput();
      alert(res.msg);
    },
    // 全球平台令牌登录
    globalUidTokenLogin() {
      this.$store
        .dispatch(GO_UID_TOKEN_LOGIN, {
          uid: this.uid,
          token: this.dynamicCode,
          ckcode: this.verificationCode,
          gameId: this.$store.state.gameId,
          packageName: globalConfig.getHrefParam('packageName')
        })
        .then(res => {
          if (res.result) {
            this.tokenLoginSuccessHandle();
          } else {
            this.checkNeedVerificationCode();
            this.tokenLoginFailHandle(res);
          }
        });
    },
    // 日本平台令牌登录
    jpUidTokenLogin() {
      let actionName = '';
      let params = {
        token: this.dynamicCode,
        gameId: this.$store.state.gameId
      };
      if (this.isPopupMode) {
        actionName = GET_JPSTORE_TOKEN_LOGIN_BY_UID;
        Object.assign(params, {
          uid: this.$store.state.login.uid
        });
      } else {
        actionName = GO_UID_TOKEN_LOGIN;
      }
      this.$store.dispatch(actionName, params).then(res => {
        res.result
          ? this.tokenLoginSuccessHandle()
          : this.tokenLoginFailHandle(res);
      });
    },
    backToSelectLoginWay() {
      this.$store.commit(UPDATE_UID_TOKEN_LOGIN_STATUS, false);
    },
    // 判断是否需要输入验证码
    checkNeedVerificationCode() {
      this.$store.dispatch(CHECK_NEED_VERIFICATION_CODE).then(res => {
        if (res.result) {
          if (res.data && +res.data.NEED_CKCODE === 1) {
            this.needVerticationCode = true;
            this.refreshVerificationImg();
          } else {
            this.needVerticationCode = false;
          }
        } else {
          alert(res.msg);
        }
      });
    },
    randomNumber(min, max) {
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      const number = randomBuffer[0] / (0xffffffff + 1);
      return Math.floor(number * (max - min) + min);
    },
    initViewport
  },
  components: {
    UidTokenGuidePopup,
    BeautyTokenGuidePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.uid-token {
  margin: 0 auto;
  background-size: cover;
  @psetbg ('uid-token-bg.png');
  &-content {
    margin: 0 auto;
    width: 543px;
  }
  &-title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 41px 0 0;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: var(--login-uidtoken-title);
    .ask {
      display: inline-block;
      margin-left: 12px;
      background-size: cover;
      cursor: pointer;
      @psetbg ('uid-token-ask.png');
    }
  }
  &-back {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 24px;
    color: var(--login-uidtoken-back);
    &-ico {
      display: inline-block;
      margin-right: 12px;
      background-size: cover;
      @psetbg ('uid-token-return-ico.png');
    }
  }
  &-input-label {
    margin-bottom: 17px;
    font-size: 24px;
    text-align: left;
    color: var(--login-uidtoken-input-title);
  }
  &-input-box {
    box-sizing: border-box;
    margin: 0 0 15px;
    padding: 0 38px;
    background-color: transparent;
    background-size: cover;
    font-size: 24px;
    color: #fff;
    @psetbg ('uid-token-uid-input.png');
  }
  &-dynamic-code {
    display: flex;
    justify-content: space-between;
    .uid-token-input-box {
      background-color: transparent;
      background-size: cover;
      text-align: center;
      @psetbg ('uid-token-dynamic-input.png');
    }
  }
  &-verification-code {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .verification {
      margin-bottom: 0;
      background-color: transparent;
      background-size: cover;
      @psetbg ('uid-token-vertification-input.png');
    }
    .verification-img {
      width: 94px;
      height: 49px;
    }
    .refresh-ico {
      display: inline-block;
      background-size: cover;
      @psetbg ('uid-token-refresh.png');
    }
  }
  &-login-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 33px auto 0;
    background-size: cover;
    cursor: pointer;
    line-height: 79px;
    font-size: 30px;
    color: var(--login-uidtoken-btn);
    @psetbg ('uid-token-btn.png');
  }
}
@media screen and (orientation: landscape) {
  .uid-token {
    background-size: cover;
    @psetbg ('uid-token-bg-hen.png');
    &-back {
      font-size: 20px;
    }
    &-input-label {
      margin-bottom: 8px;
      font-size: 14px;
    }
  }
}
</style>
